import "./KoFi.css";

function KoFi(props) {
  const { color, id, label } = props;

  return (
    <div className="btn-container">
      <a
        title={label}
        className="flex items-center rounded-md px-4 py-1"
        style={{ backgroundColor: color }}
        href={"https://ko-fi.com/" + id}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="flex items-center text-xs">
          <img
            src="https://ko-fi.com/img/cup-border.png"
            className="inline h-3 mr-2 animate-wiggle"
            alt="Ko-Fi button"
          />
          {label}
        </span>
      </a>
    </div>
  );
}

export default KoFi;
